module.exports = __webpack_public_path__ + "media/images/modals/Okra_And_Beats_Juneteenth_Celebration_sm-0cee5959b776056caf3339a024c9c4df.jpeg";